import ImageThumbnail from './image_thumbnail'

export default class Image {
  constructor(object) {
    this.url = object.url || null
    this.thumb = object.thumb ? new ImageThumbnail(object.thumb) : null
  }
}

export function createImageWithUrl(url) {
  return new Image({
    url,
    thumb: { url }
  })
}
